import Component from '../inherited/Component';

export default class ImageWithZoom extends Component {
    constructor(elem, theme, options, ctx) {
        super(elem, theme, options, ctx);
    }

    mount() {
        this._elem.addEventListener('click', () => {
            this._elem.classList.add('active');
        });

        this._elem.addEventListener('mousemove', (e) => {
            this._elem.style.backgroundPositionX =
                (e.offsetX / this._elem.clientWidth) * 100 + '%';
            this._elem.style.backgroundPositionY =
                (e.offsetY / this._elem.clientHeight) * 100 + '%';
        });

        this._elem.addEventListener('mouseleave', () => {
            this._elem.classList.remove('active');
        });
    }
}
